import React, { ReactNode } from 'react'
import { SidebarLayout, useForTablet } from '@sketch/components'
import { usePrototypeStatus } from '@sketch-hq/sketch-web-renderer'
import { useVersioning } from 'modules/versioning'
import ShareWorkspaceSidebar from 'modules/shares/components/ShareWorkspaceSidebar'
import { PrototypeEmptyHeader, PrototypeHeader } from '../PrototypeHeader'
import { PrototypeFooter } from '../PrototypeFooter/PrototypeFooter'

type PrototypeLayoutProps = {
  children: ReactNode
}

/**
 * Top-level global layout for everything shown within the Prototype view.
 */
export function PrototypeLayout(props: PrototypeLayoutProps) {
  const status = usePrototypeStatus()
  const versioning = useVersioning()
  const isTabletAndBigger = useForTablet()
  const isReady = status.type === 'READY'

  return (
    <SidebarLayout
      darkBackground
      sidebarLeft={
        <ShareWorkspaceSidebar
          workspaceIdentifier={versioning.share.workspace.identifier}
        />
      }
      header={headerProps =>
        isReady ? (
          <PrototypeHeader
            setSidebarLeftOpen={headerProps.setSidebarLeftOpen}
            share={versioning.share}
          />
        ) : (
          <PrototypeEmptyHeader
            setSidebarLeftOpen={headerProps.setSidebarLeftOpen}
            share={versioning.share}
          />
        )
      }
      footer={(isReady && !isTabletAndBigger && <PrototypeFooter />) || null}
    >
      {props.children}
    </SidebarLayout>
  )
}
